<template>
  <v-container class="pa-0">
    <v-img src="/img/cpa2.png" style="width: 180px" class="mx-auto mt-10 mb-5" />
    <v-card class="rounded-t-xl pa-0 ma-0">
      <div class="text-h5 text-center font-weight-black pt-5">Área do Sócio</div>
      <v-form ref="form" class="pa-5">
        <v-text-field v-model="matricula" type="number" name="matricula" label="Matricula (do titular, consta em sua carteira social)" required></v-text-field>
        <v-text-field v-model="cpf" name="cpf" type="number" label="CPF do titular" autocomplete="off" required :error-messages="erroAjax"></v-text-field>
      </v-form>
      <v-row align="center"></v-row>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn
          class="cyan darken-2 white--text my-2"
          @click="loginSocio({ matricula, cpf })"
        >Acessar</v-btn>
      </v-card-actions>
      <div class="text-center ma-10 pt-5 pb-5">
        Se você não é sócio do clube, você deve estar procurando o login de visitante,
        <router-link to="/login/visitante">Clique aqui</router-link>
      </div>
    </v-card>
    <div
      class="text-caption text-center"
    >Sistema Desenvolvido por Revolution Serviços <a href="//wa.me/5551999926208">(51) 99992-6208</a></div>
    <v-dialog :value="loading">
      <v-card>
      <v-card-text class="text-h6 text-center">
      Efetuando Login
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </v-card-text>
    </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    cpf: '',
    matricula: ''
  }),
  mounted () {
    this.$store.commit('setErroAjax', '')
  },
  computed: {
    ...mapState(['loading', 'erroAjax'])
  },
  methods: {
    ...mapActions(['loginSocio'])
  }
}
</script>
